// extracted by mini-css-extract-plugin
module.exports = {"NewsTab":"style_NewsTab__3mpz_","TabItem":"style_TabItem__2AZB5","SubTab":"style_SubTab__2o3a-"};